module.exports = __webpack_public_path__ + "static/heroBg-cbbd39649f0556521a7b6866d85ea26a.png";